import { useParams, Link } from "react-router-dom";
import { useMemo } from "react";
import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  const category = useMemo(() => categories.find((c) => c.slug === slug), [slug]);
  const categoryArticles = useMemo(() => {
    if (!slug) return [];
    return articles.filter((a) => a.categorySlug === slug);
  }, [slug]);

  const categoryLabel = category?.name || slug;

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="pt-20 px-4 md:px-6 py-20 text-center">
          <h1 className="text-2xl font-bold text-foreground-950">分类未找到</h1>
          <Link to="/" className="text-primary-600 hover:underline mt-4 inline-block">返回首页</Link>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <SEO
        title={`${categoryLabel} - 黑料社区`}
        description={`黑料社区${categoryLabel}分类 - ${category.description}。浏览最新的${categoryLabel}资讯和深度分析文章。`}
        keywords={`${categoryLabel},黑料社区,爆料资讯,${category.name}`}
        canonicalUrl={`https://heiliaoshequ.cn/category/${slug}`}
      />
      <Navbar />
      <main className="pt-20">
        <div className="w-full px-4 md:px-6 pb-10 md:pb-14">
          <Breadcrumb
            items={[
              { label: "首页", path: "/" },
              { label: categoryLabel },
            ]}

          />
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950">{categoryLabel}</h1>
            <p className="text-foreground-500 mt-2 text-sm md:text-base">{category.description}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {categoryArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>

          {categoryArticles.length === 0 && (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-4xl text-foreground-300 mb-3 block"></i>
              <p className="text-foreground-500">该分类暂无文章</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}